import React from 'react';
import { useSelector } from 'react-redux';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';

import { getUpsellProductForFeature } from 'product-features/selectors';
import { getMessageKeyByEligibility } from 'util/productEligibility';
import ScriptingCard from './ScriptingCard';
import ScriptingCardTrigger from './ScriptingCardTrigger';
import { FEATURE_NAMES, KEYS_BY_PRODUCT } from 'constants/features';

const baseString = 'vra-manual-scripting-card';

export const getButtonText = ({
  canCreateManualScript,
  productKey
}) => {
  return canCreateManualScript
    ? 'button-text__start'
    : `button-text__upgrade--${productKey}`;
};

const ManualScriptingCard = ({
  canCreateManualScript,
  cardText=getMessage('text__basic-intro'),
  cardTitle=getMessage('title-text__manual-script'),
  onClickManualScriptTrigger
}) => {
  const eligibility = useSelector((state) => getUpsellProductForFeature(state, FEATURE_NAMES.MANUAL_SCRIPTING));

  const triggerClassString = classNames({
    [`${baseString}__trigger`]: true,
    'vra-scripting-card__trigger': true
  });

  const buttonText = getButtonText({
    canCreateManualScript,
    productKey: KEYS_BY_PRODUCT[eligibility.eligibleProduct]
  });

  const isHidden = !canCreateManualScript && (eligibility.isFetchCompleted && !eligibility.eligibleProduct);

  const button = (
    <ScriptingCardTrigger
      isDisabled={!onClickManualScriptTrigger}
      isHidden={ isHidden }
      isPrimary={ canCreateManualScript }
      onClick={ onClickManualScriptTrigger }
      testId='create-manual-prescription'
      text={getMessage(buttonText)}
      triggerClassString={triggerClassString}
    />
  );

  const upsaleEligibility = {
    eligibility,
    canCreateScript: canCreateManualScript
  };
  const messageKey = getMessageKeyByEligibility(upsaleEligibility);

  return (
    <ScriptingCard
      body={cardText}
      button={button}
      disabledMessageKey={messageKey}
      optionType='manual'
      title={cardTitle}
    />);
};

ManualScriptingCard.propTypes = {
  canCreateManualScript: propTypes.bool.isRequired,
  cardText: propTypes.string,
  cardTitle: propTypes.string,
  onClickManualScriptTrigger: propTypes.func,
};

export default ManualScriptingCard;
